import { Trans } from '@lingui/macro';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Typography } from '@material-ui/core';
import useServiceTestTypeMapping from './detail/hooks/UseServiceTestTypeMapping';

const NotFoundService = ({ group }) => {
    return (
        <Typography variant="subtitle2">
            <Trans>Can not found test type: {group}</Trans>
        </Typography>
    );
};

NotFoundService.propTypes = {
    group: PropTypes.string,
};

NotFoundService.defaultProps = {
    group: undefined,
};

/**
 * Guard component that validates the service test type and handles loading/error states.
 * Renders children (render prop) only when the type is resolved successfully.
 *
 * @param {string} group - The service test type from route params
 * @param {function} children - Render prop: (testTypeArrayObject) => ReactNode
 */
export default function ServiceTestTypeGuard({ group, children }) {
    const { testTypeArrayObject, isLoading, error, hasFetched } = useServiceTestTypeMapping(group);

    if (isEmpty(group)) {
        return (
            <Typography variant="subtitle2">
                <Trans>Test type not found.</Trans>
            </Typography>
        );
    }

    if (isLoading) {
        return null;
    }

    if (!isEmpty(error)) {
        return <NotFoundService group={group} />;
    }

    if (!hasFetched) {
        return null;
    }

    if (hasFetched && isEmpty(testTypeArrayObject)) {
        return <NotFoundService group={group} />;
    }

    return children(testTypeArrayObject);
}

ServiceTestTypeGuard.propTypes = {
    group: PropTypes.string,
    children: PropTypes.func.isRequired,
};

ServiceTestTypeGuard.defaultProps = {
    group: undefined,
};
